(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pickBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pickBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pickBy, global.convert);
    global.pickBy = mod.exports;
  }
})(this, function (exports, _pickBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pickBy = undefined;

  var _pickBy3 = _interopRequireDefault(_pickBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object picking properties that <code>predicate</code> returns truthy for.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example pickBy({ nested: { a: 1, b: 2, c: 3, d: 4 } }, 'nested', v => v < 3) // => { nested: { a: 1, b: 2 } }
   * @see {@link https://lodash.com/docs#pickBy|lodash.pickBy} for more information.
   * @since 0.1.12
   */
  var pickBy = (0, _convert.convert)(_pickBy3.default);
  exports.pickBy = pickBy;
  exports.default = pickBy;
});